import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      clipPath: "url(#IconProductPanorama36016a)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M8 2.4A1.2 1.2 0 1 0 8 0a1.2 1.2 0 0 0 0 2.4ZM6.3 3a.8.8 0 0 0-.8.8V7h1v4h1L8 7.87 8.5 11h1V7h1V3.8a.8.8 0 0 0-.8-.8H6.3Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M2 11.378v.005l.001.009a.183.183 0 0 0 .015.036.762.762 0 0 0 .149.19c.181.177.497.386.973.59.927.398 2.278.697 3.862.788V12l3 2-3 2v-1.036l-.002.035c-1.788-.092-3.425-.428-4.648-.953-.61-.26-1.166-.59-1.585-1C.343 12.632 0 12.07 0 11.383c0-1.078.816-1.828 1.601-2.288.837-.492 1.956-.854 3.202-1.08l.355 1.97c-1.109.2-1.98.503-2.545.835-.28.165-.449.315-.538.428a.456.456 0 0 0-.074.13Zm11.386-.558c-.564-.332-1.435-.636-2.544-.836l.355-1.968c1.246.225 2.365.588 3.202 1.079.785.46 1.601 1.21 1.601 2.288 0 1.08-.818 1.83-1.604 2.29-.84.492-1.96.855-3.208 1.08l-.355-1.969c1.112-.2 1.985-.504 2.551-.836.283-.165.45-.316.54-.429a.457.457 0 0 0 .075-.13v-.004l.001-.002v-.005a.455.455 0 0 0-.075-.13c-.09-.113-.257-.263-.539-.428Z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "IconProductPanorama36016a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      })
    })]
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconProductPanorama36016 = createIcon(IconComponent);